export { default } from './DemographicsItems';
